module.exports = __webpack_public_path__ + "static/media/single_guy_icon.ac059c03.svg";